/**
 * The Scarecrow pack (ADR 0031), a Halloween costume that echoes the
 * meadow's night of the Great Scarecrow and the Burnt Farm: a carved
 * pumpkin lit from inside (animated, the candle flickers), straw-stuffed
 * rags, a scythe, a harvest lantern (animated flame) and a crow at the
 * side. A costume of the monster, not the monster: the boss wears a
 * burlap sack and a hat, the player a pumpkin. Seasonal by intent; the
 * shop has no time window, so it sells all year until one exists.
 */
const PIECES = [
    {
        id: 'scarecrow-pumpkin',
        name: 'Tête de citrouille',
        slot: 'helmet',
        blurb: 'Une citrouille sculptée, une chandelle qui vacille derrière les yeux. Animée.',
        priceCents: 299,
    },
    {
        id: 'scarecrow-rags',
        name: 'Haillons de l’épouvantail',
        slot: 'chest',
        blurb: 'Un pourpoint rapiécé, bourré de paille qui dépasse aux coutures.',
        priceCents: 399,
    },
    {
        id: 'scarecrow-gloves',
        name: 'Gants de l’épouvantail',
        slot: 'gloves',
        blurb: 'De vieux gants de toile, la paille qui sort aux poignets.',
        priceCents: 199,
    },
    {
        id: 'scarecrow-boots',
        name: 'Bottes de l’épouvantail',
        slot: 'boots',
        blurb: 'Des bottes usées jusqu’à la corde, la paille aux chevilles.',
        priceCents: 199,
    },
    {
        id: 'scarecrow-scythe',
        name: 'Faux de l’épouvantail',
        slot: 'weapon',
        blurb: 'Une faux rouillée au manche noueux, portée par-dessus ton arme.',
        priceCents: 399,
    },
    {
        id: 'scarecrow-lantern',
        name: 'Lanterne des moissons',
        slot: 'offhand',
        blurb: 'Une lanterne de fer où danse une flamme orange. Animée.',
        priceCents: 299,
    },
];
const CROW = {
    id: 'scarecrow-crow',
    name: 'Corbeau de minuit',
    blurb: 'Un corbeau noir aux yeux de braise qui te suit de champ en champ.',
    priceCents: 299,
};
const PACK_ITEMS = [...PIECES.map((piece) => piece.id), CROW.id];
export const SCARECROW = {
    templates: [
        ...PIECES.map((piece) => ({
            id: piece.id,
            lootable: false,
            cosmetic: true,
            name: piece.name,
            kind: 'equipment',
            slot: piece.slot,
            rarity: 'epic',
            ...(piece.slot === 'offhand' ? { classes: ['warrior'] } : {}),
            sprite: `overlay.${piece.id}`,
            icon: `icon.${piece.id}`,
        })),
        {
            id: CROW.id,
            lootable: false,
            name: CROW.name,
            kind: 'equipment',
            slot: 'pet',
            rarity: 'epic',
            companion: CROW.id,
            icon: `icon.${CROW.id}`,
        },
    ],
    offers: [
        ...[...PIECES, CROW].map((single) => ({
            id: single.id,
            name: single.name,
            blurb: single.blurb,
            pack: 'scarecrow',
            items: [{ templateId: single.id }],
            priceCents: single.priceCents,
        })),
        {
            id: 'scarecrow-pack',
            name: 'Pack de l’Épouvantail',
            blurb: 'Le costume de la nuit du Grand Épouvantail : la tête de citrouille, les haillons, les gants, les bottes, la faux, la lanterne et le corbeau de minuit.',
            pack: 'scarecrow',
            items: PACK_ITEMS.map((templateId) => ({ templateId })),
            priceCents: 999,
            worthCents: [...PIECES, CROW].reduce((sum, single) => sum + single.priceCents, 0),
        },
    ],
};
//# sourceMappingURL=scarecrow.js.map